import { useTranslation } from 'react-i18next';
import './Dashboard.scss';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthContext } from 'contexts/AuthContext';

const getNavItems = (userRole, t) => {
  const items = [
    { icon: 'fas fa-tint', label: t('nav_pumps'), route: '/dashboard' },
  ];

  if (userRole === 3) {
    items.push({ icon: 'fas fa-calendar-alt', label: t('nav_reports'), route: '/dashboard/reports' });
    items.push({
      icon: 'fas fa-user-circle',
      label: t('nav_users'),
      route: '/dashboard/users',
    });
    return items;
  }

  items.push({ icon: 'fas fa-water', label: t('nav_pools'), route: '/dashboard/pools' });

  if (userRole === 5) {
    items.push({ icon: 'fas fa-calendar-alt', label: t('nav_reports'), route: '/dashboard/reports' });
    return items;
  }

  items.push({ icon: 'fas fa-calendar-alt', label: t('nav_reports'), route: '/dashboard/reports' });

  if (userRole === 1 || userRole === 2 || userRole === 4) {
    items.push({
      icon: 'fas fa-user-circle',
      label: t('nav_users'),
      route: '/dashboard/users',
    });
  }

  return items;
};

export default function DashboardNavMobile() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { userRole } = useAuthContext();

  const navItems = getNavItems(userRole, t);

  const getActive = (route) => {
    if (route === '/dashboard') {
      return location.pathname === '/dashboard' || location.pathname.startsWith('/dashboard/pump');
    }
    if (route.startsWith('/dashboard/users')) {
      return location.pathname.startsWith('/dashboard/users');
    }
    return location.pathname.startsWith(route);
  };

  const handleItemClick = (item) => {
    if (item.route) {
      navigate(item.route);
    }
  };

  return (
    <nav className="dashboard-nav dashboard-nav-bottom d-md-none">
      {navItems.map((item, idx) => (
        <div
          key={idx}
          className={`dashboard-nav-item${getActive(item.route) ? ' active' : ''}`}
          onClick={() => handleItemClick(item)}
          style={{
            cursor: item.route ? 'pointer' : 'default'
          }}
        >
          <i className={item.icon} />
          <div className="dashboard-nav-label">{item.label}</div>
        </div>
      ))}
    </nav>
  );
}
